import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRatemds = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2 12C2 6.46419 6.46394 2 11.9995 2C17.5351 2 22 6.46419 22 12C22 17.5358 17.5351 22 11.9995 22C6.46394 22 2 17.5358 2 12Z",
			fill: "#009999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9643 12.893H18.2499C17.9283 12.893 17.5713 12.607 17.4998 12.3214L15.7855 5.39301C15.6781 4.92836 15.4644 4.67859 15.1428 4.67859C14.8212 4.67859 14.607 4.92836 14.5001 5.42836L11.7855 18.3214L9.67861 9.7144C9.57126 9.25022 9.35702 8.99998 9.0359 8.99998C8.71431 8.99998 8.50008 9.24975 8.39319 9.7144L7.39296 14.1428V14.1786L7.35702 14.1428L7.07137 13.7856C6.67884 13.2856 5.85737 12.8925 5.17872 12.8925H2.03613C2.07161 13.1786 2.10754 13.5 2.14348 13.7856H5.21466C5.6072 13.7856 6.17896 14.0711 6.39319 14.3572L6.67884 14.7144C6.92855 15.0353 7.28561 15.1786 7.60766 15.107C7.92878 15.0358 8.17849 14.7502 8.2499 14.3572L9.07137 10.7856L11.2142 19.4646C11.3215 19.9284 11.5358 20.1786 11.8574 20.1786C12.1785 20.1786 12.3927 19.9284 12.5001 19.4284L15.2142 6.53533L16.6424 12.5353C16.8212 13.2502 17.4998 13.7856 18.2499 13.7856H21.8569C21.8928 13.5 21.9283 13.1791 21.9643 12.893Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgRatemds);
export { ForwardRef as ReactComponent };
